/* FlushGut — "Choose Your FlushGut" format picker, and add to cart.
 *
 * One level of choice: Jelly / Gummy / Capsule. These are separate products in
 * this catalogue, not variants of one, so selecting a format swaps both the
 * variant and the selling plan.
 *
 * The Orange/Berry flavour switch this file used to carry is gone. v2 of the
 * comp (2026-09-04) has no flavour control on the homepage — the Jelly card
 * sells the product set on its block (Orange, per Jared 2026-09-04) and flavour
 * is chosen on the product page. Do not re-add it here without the comp.
 *
 * A card with data-live="false" is inert: it cannot be selected, and the CTA
 * stays disabled unless another card is selectable. A draft product reads as
 * not available, so Gummy and Capsule are inert until someone publishes them.
 */
(function () {
  'use strict';

  function init() {
    var box = document.getElementById('fg-buy-box');
    if (!box) return;

    var cards = Array.prototype.slice.call(box.querySelectorAll('[data-format]'));
    var form = box.querySelector('[data-atc-form]');
    var variantInput = box.querySelector('[data-variant-input]');
    var planInput = box.querySelector('[data-selling-plan-input]');
    var onetimeBtn = box.querySelector('[data-onetime]');
    var submitBtn = box.querySelector('[data-atc-btn]');

    var subscribing = true;
    var selected = null;

    function isLive(card) { return card.getAttribute('data-live') === 'true'; }

    // ── Format ─────────────────────────────────────────────────────────────
    function select(card) {
      if (!card || !isLive(card)) return;
      selected = card;
      cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        var head = c.querySelector('.fg-format__head');
        if (head) head.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      sync();
    }

    function sync() {
      if (!selected) {
        if (submitBtn) submitBtn.disabled = true;
        return;
      }
      if (variantInput) variantInput.value = selected.getAttribute('data-variant-id') || '';
      var plan = selected.getAttribute('data-selling-plan') || '';
      if (planInput) {
        planInput.value = subscribing ? plan : '';
        planInput.disabled = !subscribing || !plan;
      }
      if (submitBtn) submitBtn.disabled = !variantInput || !variantInput.value;
    }

    cards.forEach(function (card) {
      var head = card.querySelector('.fg-format__head');
      if (!head) return;
      head.addEventListener('click', function () { select(card); });
      head.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(card); }
      });
    });

    if (onetimeBtn) {
      onetimeBtn.dataset.subscribeLabel = onetimeBtn.textContent.trim();
      onetimeBtn.setAttribute('aria-pressed', 'false');
      onetimeBtn.addEventListener('click', function () {
        subscribing = !subscribing;
        onetimeBtn.setAttribute('aria-pressed', subscribing ? 'false' : 'true');
        onetimeBtn.textContent = subscribing
          ? onetimeBtn.dataset.subscribeLabel
          : 'Back to Subscribe & Save';
        sync();
      });
    }

    select(cards.filter(isLive)[0]);
    sync();

    // ── Add to cart ────────────────────────────────────────────────────────
    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (!variantInput || !variantInput.value) return;

        var label = submitBtn ? submitBtn.querySelector('[data-cta-label]') : null;
        var defaultLabel = submitBtn ? submitBtn.dataset.defaultLabel : '';
        if (submitBtn) submitBtn.disabled = true;
        if (label) label.textContent = 'Adding…';

        var payload = { id: parseInt(variantInput.value, 10), quantity: 1 };
        if (planInput && !planInput.disabled && planInput.value) {
          payload.selling_plan = parseInt(planInput.value, 10);
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [payload] })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (e) { throw e; });
            return res.json();
          })
          .then(function () {
            openCartDrawer();
            if (submitBtn) submitBtn.disabled = false;
            if (label) label.textContent = defaultLabel;
          })
          .catch(function (err) {
            console.error('[FlushGut] add to cart failed:', err);
            if (submitBtn) submitBtn.disabled = false;
            if (label) label.textContent = 'Try again';
          });
      });
    }

    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      var notification = document.querySelector('cart-notification');
      if (notification && typeof notification.open === 'function') { notification.open(); return; }
      window.location.href = '/cart';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
